export const getAdminTourSteps = (t) => [
  {
    selector: '[data-tour-id="nav-Item"]',
    content: t("admin.walkthrough.navItem"),
    position: 'right',
  },
  {
    selector: '[data-tour-id="date-filter"]',
    content: t("admin.walkthrough.date"),
    position: 'bottom',
  },
  {
    selector: '[data-tour-id="download-report"]',
    content: t("admin.walkthrough.download"),
    position: 'left',
  },
  {
    selector: '[data-tour-id="agents-table"]',
    content: t("admin.walkthrough.edit"),
    position: 'top',
  },
];

export const getClientTourSteps = (t) => [
  {
    selector: '[data-tour-id="clients-table"]',
    content: t("admin.walkthrough.clientTable"),
    position: 'bottom',
  },
];
export const getClientPopupTourSteps = (t) => [
  {
    selector: '[data-tour-id="company-note"]',
    content: t("admin.walkthrough.companyNote"),
    position: 'bottom',
  },
];

export const getUploadTourSteps = (t) => [
  {
    selector: '[data-tour-id="download-error"]',
    content: t("admin.walkthrough.downloadError"),
    position: 'bottom',
  },
  {
    selector: '[data-tour-id="error-upload"]',
    content: t("admin.walkthrough.errorUpload"),
    position: 'bottom',
  },
  
];